import SOCKET_OPTIONS from "../socket-variables";
import {io, Socket} from "socket.io-client";

// Export the socket factory instead of an instance
export function createSocket(): Socket {
    // Authentication and lifecycle handlers must be attached before the first
    // namespace handshake. Post-login orchestration calls connect() once the
    // firm, user and token have been stored.
    return io(SOCKET_OPTIONS.hostname, {...SOCKET_OPTIONS, autoConnect: false});
}

// Export a ref that will hold the socket instance
export let socket: Socket | null = null;

export function setSocket(socketInstance: Socket) {
    socket = socketInstance;
}
